import React from "react";
import { Tooltip, TooltipProps } from "@mui/material";

export const ColoredTooltip = ({
  backgroundColor,
  ...props
}: Omit<TooltipProps, "componentsProps"> & { backgroundColor: string }) => (
  <Tooltip
    componentsProps={{
      tooltip: {
        sx: { backgroundColor, borderRadius: "6px", padding: "6px 12px" },
      },
      arrow: { sx: { color: backgroundColor } },
    }}
    {...props}
  />
);
